// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bf_fm","conditions__content":"bf_fn","conditions__footer":"bf_fp"};